export const AppConfiguration = {
  isProduction: false,
  serverUrl: 'https://api.alpha.hawkdev.xyz/backend',
  version : 'alpha-0.0.215',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_8vyza1oJi',
  aws_user_pools_web_client_id: '6dsmep6rcvk986s91lsp7k74jg',
  oauth: {}
};
